// Tiny runtime helpers to tell which shell the app is loaded in.
//
// We use these to hide UI that wouldn't be appropriate inside the
// iOS Capacitor build — most importantly the "Subscribe" call to
// action. Apple's App Store guidelines say a free app can't sell
// digital subscriptions outside of In-App Purchase, but B2B SaaS
// apps that gate features on a *real-world service* sold via the
// company's website (Slack, Notion, Salesforce, etc.) are
// allowed — provided the iOS app itself doesn't link out to or
// promote that purchase. So inside Capacitor we render only
// sign-in. Subscription is purchased exclusively on the web.

// True when running inside the Capacitor iOS / Android shell.
// Capacitor injects a global `Capacitor` object on native; on the
// web the global is undefined. Tested at module load (cheap).
export const isNative: boolean = (() => {
  if (typeof window === "undefined") return false;
  // The Capacitor global isn't part of the standard window types,
  // so cast through unknown.
  const cap = (window as unknown as {
    Capacitor?: { isNativePlatform?: () => boolean };
  }).Capacitor;
  return Boolean(cap?.isNativePlatform?.());
})();

// True on phone / tablet web AND on native — anywhere we want a
// touch-first layout. Different from isNative; e.g. iPad Safari
// returns true here but false from isNative.
export function isTouchDevice(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(hover: none) and (pointer: coarse)").matches
    ?? false;
}
